import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=75b5ce6c&scoped=true"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=75b5ce6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b5ce6c",
  null
  
)

export default component.exports